/**
 * t263u: the small muted line under a done subtask: "Completed by Jane Smith · Today 14:32". The name opens the
 * person sheet. Nothing shows for tasks completed before this was recorded (completed_by null).
 */
import { PersonButton } from '@/features/people/PersonDrawer';
import { useMembers } from '@/lib/hooks';
import { whenStamp } from '@/lib/format';

export function CompletedBy({ t, className }: { t: { completed_at: string | null; completed_by?: string | null }; className?: string }) {
  const { byId } = useMembers();
  if (!t.completed_at || !t.completed_by) return null;
  const name = byId.get(t.completed_by)?.display_name ?? 'Someone';
  return (
    <div className={`truncate text-xs text-slate-500 dark:text-slate-400 ${className ?? ''}`} data-testid="subtask-completed-by">
      Completed by <PersonButton userId={t.completed_by} name={name} className="rounded font-medium text-slate-600 hover:underline dark:text-slate-300">{name}</PersonButton> · {whenStamp(t.completed_at)}
    </div>
  );
}
